import AreaChart from "../../../../components/areaChart/areaChart";
import { connect } from "react-redux";
export default connect(state => ({
  tooltipName: "Net Units",
  hideLegend: true,
  chartData: state.membershipUnits.membershipUnits.unitsDayOverDayComparison,
  width: 1350,
  hideCurrency: true
}))(AreaChart);
